<template>
  <div id="zorder">
    <!--导航区-->
    <ul class="nav flex-box">
      <li
        :class="{ac:see === index}"
        v-for="(n, index) in nav"
        :key="index"
        @click="see = index"
      >{{ n}}</li>
    </ul>

    <!--订单列表区-->
    <ul class="list">
      <li class="item" v-for="(n, index) in 12" :key="index">
        <div class="bigs relativeItem">
          <router-link to="/zod" class="allA"></router-link>
          <div class="t flex-box relativeItem">
            <img src="../../assets/zshop/order.png" />
            <span>朱贝直营</span>
            <!-- <i class="centerY red absoluteItem">等待付款</i> -->
            <i class="centerY red absoluteItem">已退款</i>
            <!-- <i class="centerY red absoluteItem">已付款</i>
           <i class="centerY absoluteItem">已完成</i>
            <i class="centerY grey absoluteItem">已取消</i>-->
          </div>

          <div class="content flex-box relativeItem">
            <div class="img">
              <img class src="../../assets/blankimgcover.jpg" />
            </div>
            <p class="p1">
              科迪 浓缩暖酸奶 袋装5ml
              男女都喜欢，早餐营养...
            </p>
            <p class="p2">￥168.00</p>
            <p class="p3 absoluteItem">x2</p>
          </div>

          <div class="count">
            <span>共2件</span>&nbsp;
            <span>合计</span>
            <span class="price red">
              ￥
              <i>168.00</i>
            </span>
          </div>
        </div>

        <div class="an">
          <!-- <button>修改订单</button> -->
          <button @click="click_button">取消订单</button>
          <!-- <button>前往评价</button> -->
          <!-- <button>再次购买</button> -->
          <button class="get" @click="click_button">确认收货</button>
          <button class="pay" @click="click_button">去付款</button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "zorder",
  data() {
    return {
      nav: ["全部", "待付款", "待收货", "已完成", "已取消"],
      see: 0
    };
  },
  methods: {
    //按钮点击反馈
    click_button(e) {
      let t = null;
      if (e.target.className == "pay") {
        e.target.className += "pay payclick";
        t = setTimeout(() => {
          e.target.className = "pay";
          clearTimeout(t);
          this.$router.push({ path: "/zpay" });
        }, 100);
      } else if (e.target.className == "get") {
        e.target.className += "get getclick";
        t = setTimeout(() => {
          e.target.className = "get";
          clearTimeout(t);
          // this.$router.push({path:"/zpay"});
        }, 100);
      } else {
        e.target.className += "anclick";
        t = setTimeout(() => {
          e.target.className = "";
          clearTimeout(t);
          this.$router.push({ path: "/zod" });
        }, 100);
      }
    }
    //获取个人信息
    // getInfo() {
    //   let _this = this;
    //   let data = {};
    //   this.$jsonp(this.$apis("me"), data, res => {
    //     _this.info = res.data.data.result;
    //   });
    // },
  },
  mounted: function() {
    this.$tool.setTitle("我的订单");
  }
};
</script>








<style scoped>
.nav {
  background: white;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  font-size: 13px;
  color: #999;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  z-index: 2;
}
.nav li {
  width: 25%;
  text-align: center;
}
.nav .ac {
  position: relative;
  font-size: 18px;
  color: #333;
}
.nav .ac::after {
  position: absolute;
  content: "";
  width: 10px;
  height: 4px;
  border-radius: 3rem;
  background: #333;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
}

.list {
  padding-top: 45px;
}
.list li {
  padding: 0 5%;
  background: white;
  margin-bottom: 5px;
}
.t {
  padding: 10px 0;
  font-size: 14px;
  align-items: center;
  width: 100%;
}
.red {
  color: #ff6161;
}
.grey {
  color: #999;
}
.t i {
  font-style: normal;
  right: 0;
}
.t img {
  width: 17px;
  margin-right: 10px;
}

.content {
  justify-content: space-between;
}
.content .img {
  width: 76px;
  height: 76px;
  border-radius: 8px;
  overflow: hidden;
}
.content .p1 {
  width: 50%;
  font-size: 14px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.content .p2 {
  font-size: 14px;
}
.content .p3 {
  bottom: 0;
  right: 0;
  color: #999;
  font-size: 13px;
}
.count {
  width: 100%;
  padding: 10px 0;
  text-align: right;
  font-size: 14px;
  margin-top: 5px;
}
.count .price i {
  font-style: normal;
  font-size: 16px;
}

.an {
  width: 100%;
  padding: 8px 0;
  overflow: hidden;
}
.an button {
  float: right;
  width: 81px;
  height: 29px;
  border: 1px solid #707070;
  border-radius: 3rem;
  background: none;
  margin-left: 12px;
}
.an .get {
  border: 1px solid #ff6161;
  background: rgba(255, 97, 97, 0.1);
  color: #ff6161;
}
.an .pay {
  border: 1px solid #b840ff;
  background: rgba(184, 64, 255, 0.1);
  color: #b840ff;
}
.an .anclick {
  background: rgba(0, 0, 0, 0.3);
  color: white;
}
.an .payclick {
  border: 1px solid #b840ff;
  background: rgba(184, 64, 255, 1);
  color: white;
}
.an .getclick {
  border: 1px solid #ff6161;
  background: rgba(255, 97, 97, 1);
  color: white;
}
.allA{
  z-index: 1;
}
</style>
